const config = require('../config/config');
const baseUrl = config.baseUrl;

// dev
const baseWriteUrl = baseUrl + "/write/api/v1/";
const baseReadUrl = baseUrl + "/read/api/v1/";
const cmsWriteUrl = baseUrl + "/write/api/v1/cms/";

const s3bucketEndpoint = 'https://s3-upload.airwaybill.com/api/write/uploadfile';

const API = {
  baseUrl: baseUrl,

  signUpWithEmail: baseWriteUrl + 'signup/email',
  signUpWithFacebook: baseWriteUrl + 'signup/facebook',
  registerPhoneNumber: baseWriteUrl + 'register/phone_number',

  signinWithFacebook: baseWriteUrl + 'signin/facebook',
  signinWithEmail: baseWriteUrl + 'signin/email',
  verifyUser : baseWriteUrl + 'verifyUser',
  editProfileImage : baseWriteUrl + 'editprofileimage',

  shippingDashboard: baseReadUrl + 'shipping/website/dashboard',
  carryingDashboard: baseReadUrl + 'carrying/website/dashboard',
  receivingDashboard: baseReadUrl + 'receiving/website/dashboard',
  getMessageThread: baseReadUrl + 'getmessagesthread',
  getAllNotifications : baseReadUrl + 'getAllNotifications',
  getAllNotificationsSettings : baseReadUrl + 'getnotificationsettings',
  setAllNotificationSettings : baseWriteUrl + 'updateNotificationSettings',
  deleteNotification : baseWriteUrl + 'deleteNotifications',
  readNotification : baseWriteUrl + 'updateNotificationStatus',

  forgotPassword: baseWriteUrl + 'forgotpassword',
  signout: baseWriteUrl + 'logout',

  getShipmentDetails: baseReadUrl + 'view/shipment/details',
  getShipmentOffers: baseReadUrl + 'view/offers',

  viewProfile: baseReadUrl + 'viewprofile',
  getProfileReviews: baseReadUrl + 'getprofilereviews',
  updateProfile : baseWriteUrl + 'editProfile',
  updatePassword : baseWriteUrl + 'changepassword',
  sendFeedback : baseWriteUrl + 'givefeedback',
  contactSupport:baseWriteUrl + 'registersupportmessage',
  applyPromoCode: cmsWriteUrl + 'applyPromoCode',

  flagShipments: baseWriteUrl + 'flagShipment',

  allQuestionAns : baseReadUrl + 'get/all/questions',
  answer : baseWriteUrl + 'answer/question',
  askAQuestion : baseWriteUrl + 'add/question',
  flagAQuestion : baseWriteUrl + 'flagQuestion',

  createShipment : baseWriteUrl + 'create/shipment',
  updateShipment : baseWriteUrl + 'update/shipment',
  getDefaultDiscount : baseReadUrl + 'getdefaultcard',
  getShipmentCategories : baseReadUrl + 'get/item/categories',

  getShipmentStatus: baseReadUrl + 'get/shipment/status',
  viewShipmentDetails: baseUrl + '/read/api/v1.2/viewShipmentDetails',

  addEditPickUpDeliveryTime: baseWriteUrl + 'add/pickup/delivery/time',
  sendMessage: baseWriteUrl + 'sendmessage',

  acceptDeclineOffer: baseUrl + '/write/api/v1.2/accept/offer',
  cancelOffer : baseWriteUrl + 'offer/cancel',
  deleteShipment : baseWriteUrl + 'shipment/cancel',
  cancelShimentBeforeHandOff : baseWriteUrl + 'at/cancel/shipment/before/handoff',

  // makeOffer: baseWriteUrl + 'make/offer',
  firebaseToken: baseReadUrl + 'firebase/customToken',
  sendMessage: baseWriteUrl + 'sendmessage',

  s3bucketEndpoint: s3bucketEndpoint,

  browseShipment: baseReadUrl + 'browseShipments',
  browseShipmentWithFilters: baseReadUrl + 'browseShipmentsWithFilters',

  googleGeocode: 'https://maps.googleapis.com/maps/api/geocode/json',

  makeOfferAPI : baseWriteUrl + 'make/offer',

  addCard: baseWriteUrl + 'addcreditcard',
  getAllCards: baseReadUrl + 'listaddedcards',
  deleteCard: baseWriteUrl + 'removeexistingcard',
  updateDefaultCard: baseWriteUrl + 'updateexistingcard',

  startHandoff: baseWriteUrl + 'start/handoff',
  completeHandoff: baseUrl + "/write/api/v1.2/complete/handoff",

  IamOnMyWay: baseWriteUrl + 'onmyway',
  reportADelay: baseWriteUrl + 'report/delay',

  arrivedDestination: baseWriteUrl + 'arrived/destination',
  meetsRecipient: baseWriteUrl + 'meets/recipient',
  completeDelivery: baseWriteUrl + 'complete/delivery',
  amAtPickupLocation: baseWriteUrl + 'at/pickup/location',

  addPaypalAccount: baseWriteUrl + 'add/paypal/account',
  getPaypalAccount: baseReadUrl + 'get/paypal/account',
  // completeMakeOffer: baseWriteUrl + 'make/offer',

  addProfileReview: baseWriteUrl + 'addProfileReview',

  reportUser: baseWriteUrl + 'reportuser',

  addTrips : baseWriteUrl + 'addtrip',
  getAllTrips : baseReadUrl + 'gettrips',
  updateTrip : baseWriteUrl + 'updatetrip',
  deleteTrip : baseWriteUrl + 'deletetrip'
}

module.exports = API;



// WEBPACK FOOTER //
// ./app/api_config.js